import {Medium14Font} from "./FontsNewComponent/Fonts";
import React from "react";

export default function NA() {
  return <Medium14Font>N/A</Medium14Font>;
}
